import { Dispatch } from 'redux';
import styled, { breakpoints, SC } from '../../../styles/theme';
import { IFilterRule, IPriceRange, IFilterCategory } from '../../../redux/filters/filter.duck.interface';
import { TBudgetType } from '../../../interfaces/IFilters';
import { SORT_TYPE } from '../../../services';
import { CarJourneyType } from '../../../services';
import FilterBoxTemplate from './FilterBoxTemplate';
import { rem } from 'polished';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from '../../../constants/main';
import { StylesOV } from './Styles.OV';
import { StylesOVGB } from './Styles.OVGB';
import { StylesDS } from './Styles.DS';
import { StylesAP } from './Styles.AP';
import { StylesAC } from './Styles.AC';

export interface FilterBoxProps extends SC {
    filters?: IFilterRule[];
    availableFilters?: IFilterRule[];
    filterCategories?: IFilterCategory[];
    priceRange?: IPriceRange;
    budget?: TBudgetType;
    sort?: SORT_TYPE;
    isHomepage?: boolean;
    isAllowedStockJourney?: boolean;
    onChange?: (name: string, filter: IFilterRule[]) => void;
    onReset?: () => void;
    dispatch?: Dispatch;
    allTrims?: any[];
    allOffers?: any[];
    paymentJourney?: TBudgetType;
    isRouting?: boolean;
    carJourney?: CarJourneyType;
}

export const FilterBox = styled(FilterBoxTemplate)<{ isHomepage?: boolean }>`
    display: grid;
    background: ${({ theme }) => theme.colors.white};
    margin-bottom: ${({ isHomepage }) => !isHomepage && rem(40)};
    padding: ${rem(10)};
    /* -------------------------------Layout Related Css KEEP it CLEAN for maintain reasons---------------*/
    /* warning template area is space sensitive! */
    /* . symbol means that this column should be empty */
    /* for more info visit @https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-areas */
    column-gap: ${rem(0)};
    row-gap: ${rem(20)};
    min-height: ${rem(80)};
    max-width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        display: flex;
        flex-direction: column;
    }

    grid-template-areas:
        'budgetSwitch . . toggle'
        'budgetTitle . . .'
        'priceRange priceRange priceRange priceRange'
        'fuelTitle . . .'
        'fuelFilter fuelFilter fuelFilter fuelFilter'
        'gearboxTitle . . .'
        'gearboxFilter gearboxFilter gearboxFilter gearboxFilter'
        'legalText legalText legalText legalText'
        '. . . resetFilter'
        'closeButton closeButton closeButton closeButton';

    &.SOL-filter {
        grid-template-areas:
            '. . . toggle'
            'budgetTitle . . .'
            'priceRange priceRange priceRange priceRange'
            'fuelTitle fuelTitle . .'
            'fuelFilter fuelFilter fuelFilter fuelFilter'
            'gearboxTitle gearboxTitle gearboxTitle .'
            'gearboxFilter gearboxFilter gearboxFilter gearboxFilter'
            '. . . resetFilter'
            'closeButton closeButton closeButton closeButton';
    }

    @media (min-width: ${breakpoints.md}px) {
        row-gap: ${rem(5)};
        grid-template-columns: repeat(auto-fill, (minmax(120px, 1fr)));

        &.SOL-filter {
            grid-template-areas:
                'budgetTitle budgetTitle budgetTitle fuelTitle gearboxTitle'
                'priceRange priceRange priceRange fuelFilter gearboxFilter'
                'legalText legalText legalText legalText resetFilter';
        }

        grid-template-areas:
            'budgetTitle  . fuelTitle gearboxTitle'
            'priceRange priceRange fuelFilter gearboxFilter'
            'legalText legalText legalText resetFilter';
    }

    &.expanded-grid {
        max-height: fit-content;

        @media (max-width: ${breakpoints.md}px) {
            border-bottom: 5px solid ${({ theme }) => theme.colors.primary};
            margin-bottom: ${rem(58)};
        }
    }

    &.collapsed-grid {
        max-height: ${rem(60)};
        overflow: hidden;
    }

    .budgetWrapper {
        grid-area: budgetSwitch;
        margin-top: ${rem(8)};
        margin-right: ${rem(30)};
    }
    .budget-title {
        grid-area: budgetTitle;
    }

    .fuel-title {
        grid-area: fuelTitle;
    }

    .gearbox-title {
        grid-area: gearboxTitle;
    }

    .reset-filters-button {
        grid-area: resetFilter;
    }

    .frontpage-legaltext-over {
        grid-area: legalText;
    }

    .filter-grid__prices {
        grid-area: priceRange;

        @media (min-width: ${breakpoints.md}px) {
            margin-right: ${rem(25)};
        }
    }

    .filter-grid__gearbox {
        grid-area: gearboxFilter;
    }

    .filter-grid__fuel {
        grid-area: fuelFilter;
    }

    .slider-over {
        margin-top: ${rem(8)};
        min-width: ${rem(160)};
        /* margin-right: ${rem(25)}; */

        @media (max-width: calc(${breakpoints.md}px - 0.1px)) {
            margin-left: ${rem(25)};
            margin-bottom: ${rem(25)};
        }
    }

    .frontpage-legaltext-over {
        margin: 0;
    }

    .fuel-title,
    .gearbox-title,
    .budget-title {
        text-transform: uppercase;
        font-size: ${rem(18)};
    }

    .grid-button {
        min-height: ${rem(44)};
        padding: ${rem(8)} 0;

        .info-check {
            height: ${rem(14)};

            svg {
                height: ${rem(14)};
                width: ${rem(14)};
            }
        }
    }

    .reset-filters-button {
        background: none;
        border: none;
        color: ${({ theme }) => theme.colors.primary};
        text-transform: uppercase;
        cursor: pointer;
        padding: 0;
        margin-left: auto;
        margin-top: auto;

        @media (max-width: ${breakpoints.md}px) {
            margin-bottom: ${rem(-50)};
        }

        &:hover {
            color: ${({ theme }) => theme.colors.secondary};
        }
    }

    .toggle-filters {
        display: flex;
        flex: none;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        background-color: ${({ theme }) => theme.colors.black3};
        color: ${({ theme }) => theme.colors.white};
        border: 0;
        width: 100%;
        padding: ${rem(12)} ${rem(16)};
        text-transform: uppercase;
        font-size: 1.3em;

        span {
            display: flex;
            align-items: center;

            > div {
                margin-right: ${rem(12)};
            }
        }

        .filters-title-badge {
            font-size: ${rem(12)};
            border-radius: ${rem('3px')};
            margin-left: ${rem(12)};
            color: ${({ theme }) => theme.colors.white};
            background-color: ${({ theme }) => theme.colors.red1};
            width: ${rem(32)};
            height: ${rem(18)};
            justify-content: center;
        }

        @media (min-width: ${breakpoints.md}px) {
            display: none;
        }
    }

    .mobile-filter-close-button {
        position: relative;
        bottom: ${rem('-51px')};
        border: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${({ theme }) => theme.colors.black};
        color: ${({ theme }) => theme.colors.white};
        width: ${rem('228px')};
        height: ${rem('40px')};
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 0 ${rem(8)} ${rem(8)};
        cursor: pointer;
        border-top: 4px solid ${({ theme }) => theme.colors.primary};
        text-transform: uppercase;
        font-size: ${rem(11)};
        font-weight: bold;
        grid-area: closeButton;

        span {
            position: relative;
            top: -3px;
            left: 12px;
        }

        &.hidden {
            display: none;
        }
    }

    .show-if-mobile {
        @media (min-width: ${breakpoints.md}px) {
            display: none;
        }
    }

    .show-if-desktop {
        @media (max-width: ${breakpoints.md}px) {
            display: none;
        }
    }

    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && (isMarketGB ? StylesOVGB : StylesOV)}
`;

export default FilterBox;
